import myRouter from './MyRouterResolver'
import Device from 'src/pages/device/DeviceList'
import Detail from 'src/pages/device/DeviceDetail'

let router = myRouter()
router.addComponent('list', Device, {
  modules: ['radio', 'input', 'fab']
})
router.addComponent('detail/:index', Detail, {
  modules: ['input', 'accordion']
})
export default router
